import * as React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { IRelativeWorkingInCourt } from "../../../../model/report/applicantdata/RelativeWorkingInCourt";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const PDFExportRelativeWorkingInCourt = ({
  translate,
  data
}: {
  translate?: any;
  data?: IRelativeWorkingInCourt[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <View>
      <View style={styles.titleCol}>
        <Text style={styles.header}>
          {translate(
            "report8.document_template.relatives_working_in_court.title"
          )}
        </Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.relatives_working_in_court.name"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.relatives_working_in_court.relation"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.relatives_working_in_court.work_place"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.relatives_working_in_court.function"
              )}
            </Text>
          </View>
        </View>
        {data?.map((relative, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{relative.relativesName}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{relative.relation}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{relative.workPlace} </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{relative.function}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PDFExportRelativeWorkingInCourt;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});

const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "10pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "12pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginBottom: 20,
    marginLeft: 5
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  }
});
